import api from '@/modules/api.service';
import type { RelatorioAtividadeDto } from '../relatorios-atividades.types';

export async function autoSaveRelatorioUseCase(
  defensorId: number,
  defensoriaId: number,
  mes: string,
  ano: number,
  tipo: 'civil' | 'criminal',
  dados: any,
): Promise<RelatorioAtividadeDto> {
  try {
    const params = new URLSearchParams({
      mes,
      ano: String(ano),
      tipo,
    });

    const response = await api.post(
      `/relatorios/atividades/auto-save?${params.toString()}`,
      {
        defensorId,
        defensoriaId,
        dados,
      },
    );
    return response.data;
  } catch (error) {
    console.error('Erro ao salvar relatório automaticamente:', error);
    throw error;
  }
}
